<template>
    <div class="recruitInfo">
        <div class="recruitInfo__container">
            <!--==== 顶部文字  ====-->
            <div class="recruitInfo__topCon">
                <div class="recruitInfo__topCon--logo">
                    <img src="https://resource.rcclchina.com.cn/logo/PC/logoAnchorBlue.png">
                </div>
                <div class="recruitInfo__topCon--txt">
                    <p class="recruitItem__topCon--font1">皇家加勒比游轮船务（中国）有限公司</p>
                    <p class="recruitItem__topCon--font2">Great vacations begin with great employees</p>
                </div>
            </div>

            <!--==== job summary  ====-->
            <div class="recruitInfo__items">
                <div class="recruitInfo__title">
                    <p>JOB OPPORTUNITIES</p>
                </div>
                <div class="recruitInfo__itemCon">
                    <div class="item--rows">
                        <div class="item--cols">
                            <p>Title : {{position.title}}</p>
                            <p class="item--colsTxt"></p>
                        </div>
                        <div class="item--cols">
                            <p>Launch date : {{publishTime}}</p>
                            <p class="item--colsTxt"></p>
                        </div>
                    </div>
                    <div class="item--rows">
                        <div class="item--cols">
                            <p>Department : {{position.department}}</p>
                            <p class="item--colsTxt"></p>
                        </div>
                        <div class="item--cols">
                            <p>Salary : {{position.salary}}</p>
                            <p class="item--colsTxt"></p>
                        </div>
                    </div>
                    <div class="item--rows">
                        <div class="item--cols">
                            <p>Location : {{position.cityName}}</p>
                            <p class="item--colsTxt"></p>
                        </div>
                        <div class="item--cols">
                            <p>Recruitment type : {{position.recruitmentType}}</p>
                            <p class="item--colsTxt"></p>
                        </div>
                    </div>
                    <div class="item--rows">
                        <div class="item--cols">
                            <p>Send to E-mail : hrchina@rcclapac.com</p>
                            <p class="item--colsTxt"></p>
                        </div>
                        <div class="item--cols">

                        </div>
                    </div>
                </div>
            </div>

            <!--==== Essential Duties and Responsibilities  ====-->
            <div class="recruitInfo__items">
                <div class="recruitInfo__title">
                    <p>Essential Duties and Responsibilities : </p>
                </div>
                <div class="recruitInfo__itemCon">
                    <div class="recruitInfo__itemTxt" v-html="position.duties">

                    </div>
                </div>

            </div>

            <!--==== Qualifications:   ====-->
            <div class="recruitInfo__items">
                <div class="recruitInfo__title">
                    <p>Qualifications: </p>
                </div>
                <div class="recruitInfo__itemCon">
                    <div class="recruitInfo__itemTxt" v-html="position.qualifications">

                    </div>
                </div>
            </div>

            <!--==== Knowledge and Skills:     ====-->
            <div class="recruitInfo__items">
                <div class="recruitInfo__title">
                    <p>Knowledge and Skills: </p>
                </div>
                <div class="recruitInfo__itemCon">
                    <div class="recruitInfo__itemTxt" v-html="position.skills">

                    </div>
                </div>
            </div>

            <!--==== Send to E-mail : skditdm@123.com  ====-->
            <div class="recruitInfo__items">
                <div class="recruitInfo__title">
                    <div class="recruitInfo__mailbox">
                        <img src="https://resource.rcclchina.com.cn/Recruitment/mailbox.png">
                    </div>
                    <div class="recruitInfo__mailTxt">
                        <p>Send to E-mail : hrchina@rcclapac.com</p>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "RecruitmentDetail",
    data () {
        return {
            position: {}
        }
    },
    beforeMount () {
        this.initPage()
    },
    methods: {
        async initPage () {
            const positionId = this.$router.currentRoute.query.position
            if (!positionId || positionId == 0) {
                return this.goHome()
            }
            const { success, data } = await api.page.getRecruitmentDetail(positionId)
            if (!success || !data) {
                return this.goHome()
            }
            this.position = data
        },
        goHome () {
            return this.$router.push({
                name: "RecruitmentIndex"
            })
        }
    },
    computed: {
        publishTime () {
            let publishTime = this.position.launchDate + ''
            if (publishTime.length > 10) {
                publishTime = publishTime.substring(0, 10)
            }
            return publishTime.split('-').join('.')
        }
    }
}
</script>

<style lang="less" scoped>



.recruitInfo{
	width:100%;
	background:#f0f5ff;
    padding-top: 80px;
	padding-bottom: 150px;
}
.recruitInfo__container{
	width:60.0833%;
    min-width:1000px;
    background:#f0f5ff;
	margin:0 auto;
}
/*顶部文字*/
.recruitInfo__topCon{
	width: 100%;
	text-align: center;
}
.recruitInfo__topCon--logo{
	width:43px;
	height:47px;
	margin: 0 auto;
}
.recruitInfo__topCon--logo > img {
  height: 100%;
}
.recruitInfo__topCon--txt{
	margin-top: 26px;
}
.recruitInfo__topCon--txt p{
	color: #031356;
    font-weight:400;
    margin:0px;
}
.recruitItem__topCon--font1 {
    font-size: 22px;
}
.recruitItem__topCon--font2{
    font-size: 30px;
}

.recruitInfo__items{
	width:100%;
	margin-top:124px;
}
.recruitInfo__title{
	width:100%;
	margin:0 auto;
	padding-left:1%;
	border-bottom: 1px solid #031356;
}
.recruitInfo__title p{
	font-size: 18px;
	font-weight: bold;
	color: #031356;
}
.recruitInfo__itemCon{
	width:92%;
	margin:0 auto;
}
.item--rows{
	width: 100%;
	margin-top:48px;
}
.item--cols{
	width: 48%;
	display: inline-block;
	vertical-align: top;
}
.item--cols p{
	font-size: 20px;
	font-weight: 400;
	color:#3f3f3f;
	display: inline-block;
	vertical-align: top;
}
.item--colsTxt{
	width:200px;
	padding-left:10px;
	word-break: break-word;
}

.recruitInfo__itemTxt{
	margin-top:30px;
}
.recruitInfo__mailbox{
	width: 44px;
	height: 60px;
	display: inline-block;
}
.recruitInfo__mailTxt{
	display: inline-block;
}

</style>

<style lang="less">

.recruitInfo__itemTxt li p{
	font-size: 16px;
    color:#000;
}
.recruitInfo__itemTxt ul li{
	list-style-type:disc;
}
.recruitInfo__itemTxt ol {
    margin-left:-40px;
    color:#000;
}
.recruitInfo__itemTxt ol li{list-style-type:decimal;}

</style>
